<template>
  <portal to="modal" v-if="show">
    <div class="ux-modal-backdrop" @click="dismiss" v-show="show" :class="full ? 'full' : '' ">
      <div class="ux-modal" :class="blank ? 'blank' : '' ">
        <slot></slot>
      </div>
    </div>
  </portal>
</template>

<script>
export default {
  props: ["show", "blank", "full"],
  methods: {
    dismiss(ev) {
      if (ev && !ev.target.classList.contains("ux-modal-backdrop")) {
        return;
      }
      this.$emit("close");
    },
    doSelect() {}
  },
  watch: {
    show: {
      immediate: true,
      handler: show => {
        if (show) {
          document.body.style.setProperty("overflow", "hidden");
        } else {
          document.body.style.removeProperty("overflow");
        }
      }
    }
  },
  created() {
    const escapeHandler = e => {
      if (e.key === "Escape" && this.show) {
        this.dismiss();
      }
    };
    document.addEventListener("keydown", escapeHandler);
    this.$once("hook:destroyed", () => {
      document.removeEventListener("keydown", escapeHandler);
    });
  },
  mounted() {}
};
</script>
<style lang="scss" scoped>
.ux-modal-backdrop.full {
  padding: 0;
  background: rgba(black, 1);
}

div.ux-modal.blank {
  background-color: transparent;
  border: none;
  box-shadow: none;
  position: absolute;
  top: 0;
  left: 0;
  max-width: 100%;
  width: 100vw;
  height: 100vh;
  padding: 0;
  margin-top: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>

